module.exports = __webpack_public_path__ + "static/media/thumb_up.fdf2289e.png";